import {DataShape, areas} from "../App";
import {ResponsiveLine} from "@nivo/line";
import React from "react";

const TestPositivity = ({data, message}: {data: DataShape, message: string}) => {
    const testPositivityData = [{
        id: areas[message],
        data: data.metricsTimeseries.filter(el => el.testPositivityRatio !== null && el.testPositivityRatio >= 0).map(el => {
            return {
                x: el.date,
                y: el.testPositivityRatio
            }
        })
    }];

    return (
        <ResponsiveLine
            markers={[
                {
                    axis: 'y',
                    value: 0.05,
                    lineStyle: {stroke: '#b0413e', strokeWidth: 1},
                    // legend: 'y marker at 0',
                    legendPosition: 'bottom-left',
                },
            ]}
            data={testPositivityData}
            margin={{top: 10, right: 140, bottom: 50, left: 60}}
            xScale={{
                format: "%Y-%m-%d",
                type: "time",
                useUTC: false,
            }}
            xFormat="time:%Y-%m-%d"
            yScale={{type: 'linear', min: 0, max: 'auto', stacked: false, reverse: false}}
            // yFormat=" >-.2f"
            yFormat=" >-.1%"
            curve="linear"
            axisTop={null}
            axisRight={null}
            axisBottom={{
                // tickValues: "every 3 month",
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                format: "%Y-%m",
                legend: "Date",
                legendOffset: 36,
                legendPosition: "middle"
            }}
            axisLeft={{
                // orient: 'left',
                format: ">-.0%",
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: 'Percent Positive',
                legendOffset: -45,
                legendPosition: 'middle'
            }}
            enablePoints={false}
            pointSize={10}
            pointColor={{theme: 'background'}}
            pointBorderWidth={2}
            pointBorderColor={{from: 'serieColor'}}
            pointLabelYOffset={-12}
            isInteractive={true}
            // useMesh={true}
            enableSlices={"x"}
            sliceTooltip={({slice}) => {
                return (
                    <div
                        style={{
                            background: 'white',
                            padding: '9px 12px',
                            border: '1px solid #ccc',
                        }}
                    >
                        <div>{slice.points[0].data.xFormatted}</div>
                        {slice.points.map(point => (
                            <div
                                key={point.id}
                                style={{
                                    color: point.serieColor,
                                    padding: '3px 0',
                                }}
                            >
                                <strong>{point.serieId}</strong> {point.data.yFormatted}
                            </div>
                        ))}
                    </div>
                )
            }}
            legends={[
                {
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 140,
                    translateY: 0,
                    itemsSpacing: 0,
                    itemDirection: 'left-to-right',
                    itemWidth: 120,
                    itemHeight: 20,
                    itemOpacity: 0.75,
                    symbolSize: 12,
                    symbolShape: 'circle',
                    symbolBorderColor: 'rgba(0, 0, 0, .5)',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemBackground: 'rgba(0, 0, 0, .03)',
                                itemOpacity: 1
                            }
                        }
                    ]
                }
            ]}
        />
    );
}

export default TestPositivity;